import OpenInNew from "@mui/icons-material/OpenInNew";
import { Button, Dialog, DialogContent, DialogContentText, DialogTitle } from "@mui/material";

import type { DialogController } from "../../../../utils/hooks/use-dialog";
import type { UUID } from "../../../../utils/uuid";
import type { FC } from "react";

export interface RelatedMoments {
  title: string;
  moments: { id: UUID; title: string }[];
}
export const RelatedMomentsDialog: FC<{
  subjectNamedInTitle: string;
  dialog: DialogController<RelatedMoments>;
}> = ({ subjectNamedInTitle, dialog }) => (
  <Dialog open={dialog.open} onClose={dialog.handleClose}>
    <DialogTitle>
      Communications using the {subjectNamedInTitle}: {dialog.data?.title}
    </DialogTitle>
    <DialogContent>
      <DialogContentText sx={{ mb: 2 }}>
        Click to view the Communications in more detail
      </DialogContentText>
      {dialog.data?.moments.map((momentInfo) => (
        <DialogContentText key={momentInfo.id}>
          <Button
            data-analytics-id="related-moments-dialog-moment"
            href={`/moments/${momentInfo.id}`}
            target="_blank"
            endIcon={<OpenInNew />}
          >
            {momentInfo.title}
          </Button>
        </DialogContentText>
      ))}
    </DialogContent>
  </Dialog>
);
